class DataObserver {
  constructor () {
    this.init()
  }

  init () {
    this.nodes = Array.from(document.querySelectorAll('[data-observer]'))

    if ('IntersectionObserver' in window) {
      this.callback = this.callback.bind(this)
      this.observer = new IntersectionObserver(this.callback)

      for (const node of this.nodes) {
        this.observer.observe(node)
      }
    } else {
      for (const node of this.nodes) {
        this.update(node)
      }
    }
  }

  callback (entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        this.update(entry.target)
        this.observer.unobserve(entry.target)
      }
    }
  }

  update (node) {
    node.classList.add('--isIntersecting')
  }
}

new DataObserver()
